import { render, staticRenderFns } from "./Encounter_tpSchedule.vue?vue&type=template&id=385d875e&scoped=true&lang=html"
import script from "./Encounter_tpSchedule.vue?vue&type=script&lang=js"
export * from "./Encounter_tpSchedule.vue?vue&type=script&lang=js"
import style0 from "./Encounter_tpSchedule.vue?vue&type=style&index=0&id=385d875e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385d875e",
  null
  
)

export default component.exports